import { render, staticRenderFns } from "./card-task.vue?vue&type=template&id=1ae1e6a3&scoped=true"
import script from "./card-task.vue?vue&type=script&lang=js"
export * from "./card-task.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae1e6a3",
  null
  
)

export default component.exports